import { AppointmentInformation } from '../components';

export const config = {
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
};
